export type {
  POSSourceParser,
  POSImportData,
  POSParsedProduct,
  POSParsedVariant,
  POSParsedCompositeComponent,
  POSOutletInventory,
  POSParseWarning,
  OutletLocationMapping,
} from './types';

export { LightspeedParser } from './lightspeed';
export { EpayParser } from './epay';
export { DimePOSParser } from './dimepos';

import type { POSSourceParser } from './types';
import { LightspeedParser } from './lightspeed';
import { EpayParser } from './epay';
import { DimePOSParser } from './dimepos';

/**
 * Registry of all POS source parsers.
 * Add new parsers here as they become available.
 */
export const POS_SOURCES: POSSourceParser[] = [
  LightspeedParser,
  EpayParser,
  DimePOSParser,
];

/**
 * Look up a POS source parser by its id.
 */
export function getPOSSource(id: string): POSSourceParser | undefined {
  return POS_SOURCES.find(s => s.id === id);
}
